// Import necessary type
import Accounting from "../components/Accounting/Accounting";
import { BaseUrl } from "../types/Endpoints";

// Define the base URLs for different services
const baseUrl: BaseUrl = {
  auth: "https://global.cilpron.com/api/",
  email: "https://email.example.com",
  sms: "https://sms.example.com",
  crm: "https://crm.cilpron.com/internal/",
  property: "https://propertymanagement-d4ebhnfbawash4a9.canadacentral-01.azurewebsites.net/api/",
  accounting: "https://accounting.example.com",
  finance: "https://finance.example.com",
  messaging: "https://messaging-chdffxhbdxb0eqh6.eastus-01.azurewebsites.net/api/",
  retail: "https://retail.cilpron.com/api/",
  emailAPI: "https://swiftgrid.cilbox.com" // Optional property for email API
};
export const VITE_API_BASE_URL = "https://swiftgrid.cilbox.com";
export default baseUrl;

// Define WebSocket URLs for different features
export const SocketUrls = {
  messageInstances:  "wss://messaging-chdffxhbdxb0eqh6.eastus-01.azurewebsites.net", // WebSocket for messaging
  hospitalityInstances: "", // Add appropriate URL here
  emailInstances: "", // Add appropriate URL here
  crmInstances: "https://crm.cilpron.com/hubs/crm/", // Corrected typo (from crmIntances to crmInstances)
  retailInstances: "https://retail.cilpron.com/hubs/retail", // SignalR for retail
  localMessageInstances: "ws://localhost:8001",
  accountingInstances: "", // SignalR for accounting
  deliverableInstances: "https://deliverables-gebub6byc6ebhbdx.canadacentral-01.azurewebsites.net/hubs/deliverables" // SignalR for deliverables
};